<template>
    <div class="clearfix"
         :class="{active:item.symbol===symbol}">
        <div class="item"
             :class="{active:item.symbol===symbol}" @click="tap_kline">
            <el-popover
                    placement="bottom"
                    title="标题"
                    trigger="click"
            >
                <div class="k-line-view">
                    <!--图表内容区域，必须给 ECharts 容器本身指定高度。不然它会使用默认高度-->
                    <div class="chart" style="margin-top:35px;">
                        <div :id="`${kkey}-echarts`" style="height: 17.5rem"></div>
                    </div>

                    <ul class="chart-footer clearfix">
                        <li class="chart-item" v-for="item in chart_item" @click="chart_item_event(item)"
                            :class="{active:item===chart_interval}">{{item}}
                        </li>
                        <li class="chart-icon" @click="chart_btn"><i
                                :class="{iconfont:true,'icon-Kxiantu':chart_tap,'icon-tubiao-zhexiantu':!chart_tap}"></i>
                        </li>
                    </ul>
                </div>


                <span slot="reference">  {{item.symbol_mt4}}</span>
            </el-popover>
        </div>
        <div class="item">
            {{item.price.sell|toFixedInt}}
        </div>
        <div class="item">
            {{item.price.buy|toFixedInt}}
        </div>
        <div class="item">
            {{item.price.high|toFixedInt}}/{{item.price.low|toFixedInt}}
        </div>
        <div class="item">
            <i @click="chart_info(item)" class="iconfont icon-i-info"></i>
        </div>

    </div>
</template>

<script>

  import echarts from 'echarts/lib/echarts'
  import 'zrender/lib/svg/svg'
  import 'echarts/lib/chart/line'
  import 'echarts/lib/chart/candlestick'
  import chartUtil from '../../utils/chartUtil'

  export default {
    name: 'KLine',
    props: ['item', 'socket', 'symbol', 'kkey'],
    data () {
      return {
        chart: null,
        chart_tap: true,
        chart_interval: '1wk',
        chart_item: [
          '1m',
          '2m',
          '5m',
          '15m',
          '30m',
          '60m',
          '90m',
          '1h',
          '1d',
          '5d',
          '1wk'
        ],
        data_list: []
      }
    },
    mounted () {
      const that = this
      console.log('this.socket', this.socket)
      // 后端推送来的K线图数据
      this.socket.on('data', function (data) {
        that.data_list = data
        that.initChart()
      })
    },
    methods: {
      tap_kline () {
        this.socket_chart_subscriber()
      },
      tap_k_line (val) {
        this.symbol = val
        this.initChart()
        this.socket_chart_subscriber()
      },
      chart_item_event (val) {
        this.chart_interval = val
        this.socket_chart_subscriber()
      },
      initChart () {
        // 基于准备好的dom，初始化echarts实例,移动端建议使用 svg模式
        console.log(111, this.data_list)
        console.log('11111', document.getElementById(`${this.kkey}-echarts`))
        this.chart = echarts.init(document.getElementById(`${this.kkey}-echarts`), 'light', {
          renderer: 'svg'
        })
        this.chart.setOption(chartUtil.candleOption(this.data_list))

        // 图标根据窗口大小自动缩放
        // window.addEventListener("resize", this.chart.resize);
      },
      socket_chart_subscriber () {
        console.log('this.symbol', this.symbol)
        this.socket.emit('subscriber', {
          symbol: this.item.symbol,
          period1: 1533888219, // 可选，暂时没作用
          period2: 1533889219, // 可选，暂时没作用
          interval: this.chart_interval // 可选，暂时没作用
        })
      },
      chart_btn () {
        this.chart_tap = !this.chart_tap
        if (this.chart_tap) {
          this.chart.setOption(chartUtil.candleOption(this.data_list))
        } else {
          this.chart.setOption(chartUtil.lineOption(this.data_list))
        }
      }
    },
    filters: {
      toFixedInt (val) {
        /* return val.toFixed(2) */
        return parseInt(val * 100000) / 100000
      },
      numFilter (value) {
        // 截取当前数据到小数点后三位
        let transformVal = Number(value).toFixed(3)
        let realVal = transformVal.substring(0, transformVal.length - 1)
        // num.toFixed(3)获取的是字符串
        return Number(realVal)
      }
    }
  }
</script>

<style lang="scss">
    .k-line-view {
        .chart-footer {
            border: 1px solid #e0e0e0;
            border-right: none;
            width: 100%;
            margin-top: 30px;
            li {
                display: block;
                float: left;
                width: (10/12) * 10%;
                border-right: 1px solid #e0e0e0;
                text-align: center;
                line-height: 40px;
                font-size: 14px;
                cursor: pointer;
                color: #666;
                &.chart-icon {
                    font-size: 18px;
                }
                &.active {
                    background:  #0A95FF;
                    color: #fff;
                }
            }
        }
    }
</style>